// Copyright 2025, University of Maryland, All Rights Reserved
import { memo } from 'react'
import { FileText } from 'lucide-react'

import { BaseNode } from '@/subsystems/pipelines'

export const TextExtractionWorkflowNode = memo(() => (
  <BaseNode
    icon={<FileText />}
    label="Text Extraction"
    hasInput
    hasOutput
  />
))

TextExtractionWorkflowNode.displayName = 'TextExtractionWorkflowNode'
